import { token } from '@/api/client'

/** Fara sesiune nu se intra. Redirectul merge la login-ul existent —
 *  nu dublam autentificarea cat timp cele doua aplicatii ruleaza in paralel. */
export function requireSession(): boolean {
  if (token.get()) return true
  location.href = '/login.html'
  return false
}
